import * as React from 'react';
import { noop } from 'lodash';
import type { InjectedIntlProps } from 'react-intl';
import { injectIntl } from 'react-intl';
import { ProjectCardSkeleton } from 'view/help-center/project-card-skeleton';
import { ChunkLoadErrorMessage } from '@atlassian/help-center-common-component/loading';
import { LoaderContainer } from './styled';
import { ActionBarWithButtonsStateless } from '../action-bar-with-buttons-stateless';
import { FeaturedPortalsWrapper } from '../featured-portals/styled';
import { CardsContainer, ExperienceContainer, Wrapper } from '../styled';
import { UnFeaturedPortalsWrapper } from '../un-featured-portals/styled';
import { SortByFilter } from '../sort-by-filter';
import messages from './messages';
import type { LooselyLoadableLoadingComponentProps } from '@atlassian/help-center-common-component/loosely-loadable-wrapper';

export const PortalReorderExperienceLoader: React.FC<LooselyLoadableLoadingComponentProps & InjectedIntlProps> = (
    props
) => {
    return (
        <Wrapper>
            <ActionBarWithButtonsStateless isDirty={false} openPublishPrompt={noop} openCancelPrompt={noop} />
            <ExperienceContainer>
                {props.error ? (
                    <LoaderContainer>
                        <ChunkLoadErrorMessage />
                    </LoaderContainer>
                ) : (
                    <>
                        <FeaturedPortalsWrapper>
                            <h2>{props.intl.formatMessage(messages.featuredPortalsTitle)}</h2>
                            <CardsContainer>
                                {Array.from({ length: 3 }).map((_, index) => (
                                    <ProjectCardSkeleton key={index} isFeatured />
                                ))}
                            </CardsContainer>
                        </FeaturedPortalsWrapper>
                        <UnFeaturedPortalsWrapper>
                            <SortByFilter isDisabled value="POPULARITY" onChange={noop} />
                            <CardsContainer>
                                {Array.from({ length: 9 }).map((_, index) => (
                                    <ProjectCardSkeleton key={index} isFeatured />
                                ))}
                            </CardsContainer>
                        </UnFeaturedPortalsWrapper>
                    </>
                )}
            </ExperienceContainer>
        </Wrapper>
    );
};

export default injectIntl(PortalReorderExperienceLoader);
